import { useReactFlow } from '@xyflow/react';
import { useEffect } from 'react';

export const AutoFitView = ({ nodeCount }: { nodeCount: number }) => {
  const { fitView } = useReactFlow();

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      fitView({
        padding: 0.2,
        duration: 600,
      });
    }, 50);

    return () => clearTimeout(timeoutId);
  }, [nodeCount, fitView]);

  return null;
};
